"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const _ = require("lodash");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
const users_service_1 = require("./users.service");
const user_service_1 = require("./user.service");
const user_1 = require("./user");
const login_service_1 = require("./login.service");
let ResetPasswordComponent = class ResetPasswordComponent {
    constructor(_talk, _users, _router, _route, _user, _loginService) {
        this._talk = _talk;
        this._users = _users;
        this._router = _router;
        this._route = _route;
        this._user = _user;
        this._loginService = _loginService;
        this.passwordModel = { password: '', confirmPassword: '' };
        this.navigateToLogin = false;
        this.hide = false;
        this.onHidden = new core_1.EventEmitter();
    }
    ngOnInit() {
        if (!_.get(this.passwordReset, 'internal')) {
            this._route.params.subscribe((params) => {
                this.token = params['token'];
            });
        }
    }
    generatePassword() {
        let password = this._user.generatePassword();
        this.passwordModel.password = password;
        this.passwordModel.confirmPassword = password;
    }
    errors() {
        let errors = [];
        if (this.passwordModel.password !== this.passwordModel.confirmPassword) {
            errors.push('- Passwords do not match');
        }
        let validPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!.%*?&])[A-Za-z\d$@.$!%*?&]{8,}/;
        if (validPassword.test(this.passwordModel.password) == false) {
            errors.push('- Password does not meet minimum criteria');
        }
        return errors;
    }
    resetPassword() {
        return __awaiter(this, void 0, void 0, function* () {
            let errors = this.errors();
            if (errors.length) {
                let readableErrors = errors.join('<br>');
                this._talk.broadcast(readableErrors);
                return;
            }
            try {
                if (_.get(this.passwordReset, 'internal'))
                    return this.internalPasswordReset(this.passwordModel.password);
                return Promise.resolve(this._users.resetPassword(this.token, this.passwordModel.password).then(err => {
                    this._router.navigate(['/login']);
                }));
            }
            catch (err) {
                this._talk.broadcast(`Error Saving User: ${err.cause.message}`);
            }
        });
    }
    internalPasswordReset(newPassword) {
        let email = _.get(this.user, 'email') || this._user.get().email;
        this._users.forgotPassword(email, false, true)
            .then((token) => this._users.resetPassword(token, newPassword, (_.get(this.user, 'email') ? 'The password was reset' : null)))
            .then(() => {
            if (this.navigateToLogin)
                return this.logout();
            if (this.showAsModal)
                return this.closeModal();
        })
            .catch(() => this._talk.broadcast('We had a problem resetting your password.'));
    }
    resetFormFields() {
        this.passwordModel.password = "";
        this.passwordModel.confirmPassword = "";
    }
    closeModal() {
        this.resetFormFields();
        this.hide = true;
        this.passwordReset.show = false;
        this.onHidden.emit(this.hide);
    }
    logout() {
        return this._loginService.logout();
    }
};
exports.ResetPasswordComponent = ResetPasswordComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], ResetPasswordComponent.prototype, "userEmail", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], ResetPasswordComponent.prototype, "showAsModal", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], ResetPasswordComponent.prototype, "navigateToLogin", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], ResetPasswordComponent.prototype, "hide", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", user_1.User)
], ResetPasswordComponent.prototype, "user", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], ResetPasswordComponent.prototype, "passwordReset", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], ResetPasswordComponent.prototype, "onHidden", void 0);
exports.ResetPasswordComponent = ResetPasswordComponent = __decorate([
    (0, core_1.Component)({
        selector: 'reset-password',
        templateUrl: 'app/reset-password.component.html',
        styleUrls: ['styles/less/reset-password.component.less']
    }),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        users_service_1.UsersService,
        router_1.Router,
        router_1.ActivatedRoute,
        user_service_1.UserService,
        login_service_1.LoginService])
], ResetPasswordComponent);
//# sourceMappingURL=reset-password.component.js.map